import { UserReadingReport } from './userReadingReport/UserReadingReport';
import { UserCertificate } from './userCertificate/UserCertificate';
import { UserHistoryYearList } from './UserHistoryYearList';


export const UserHistoryPage = ()=>{
    return (
        <div>
            <UserHistoryYearList />
            <br />
            <UserCertificate />
            <UserReadingReport />
        </div>
    );
}